import { VoyageRoute, VoyageRoutePointFeature } from "./voyage-routing-model";

export abstract class RouteEditModelBase extends EventTarget
{
    abstract get uiRouteIndex(): number;
    abstract editRoute(uiRouteIndex: number, scheduleId: string, route: VoyageRoute, setIsPassedUpdate: boolean, etd?: number): void;
    abstract clear(): void;
    abstract setNewRoute(waypoints: VoyageRoutePointFeature[]): void;
    abstract set selectedWaypointIndex(index: number);
    abstract get selectedWaypointIndex(): number;
    abstract revert(): void;
    abstract canRevert(): boolean;
    abstract getWaypoints(): VoyageRoutePointFeature[];
    abstract saveAndCalcRoute(): Promise<void>;
}

let RouteEditModel: RouteEditModelBase|null = null;

function setRouteEditModel(model: RouteEditModelBase)
{
    RouteEditModel = model;
}

export { RouteEditModel, setRouteEditModel };
